import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { SearchInput } from '@/components/SearchInput';
import { ContinueWatchingShelf } from '@/components/continueWatching/ContinueWatchingShelf';

const SUGGESTIONS = ['Inception', 'Breaking Bad', 'The Bear', 'Dune', 'Severance'];

export function HomePage(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const goToResults = (query: string): void => {
    navigate(`/results?q=${encodeURIComponent(query)}`);
  };

  return (
    <main className="home-hero">
      <h1>
        <Trans i18nKey="home.heading" components={{ accent: <span className="accent" /> }} />
      </h1>
      <p>
        {t('home.blurb')}
      </p>

      <div className="home-hero__searchwrap">
        <SearchInput
          size="hero"
          placeholder={t('home.searchPlaceholder')}
          autoFocus
          buttonLabel={t('home.searchButton')}
          onSubmit={goToResults}
        />
      </div>

      <ContinueWatchingShelf />

      <div className="home-hero__chips" aria-label={t('home.suggestionsLabel')}>
        <strong>{t('home.tryLabel')}</strong>
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            type="button"
            className="home-hero__chip"
            onClick={() => goToResults(s)}
          >
            {s}
          </button>
        ))}
      </div>
    </main>
  );
}
